<template>
<transition name="slide">
  <div>
  <div style="background-color: #6c757d;" class="row">
  <div class="col-md-1 col-sm-1 col-xs-1">
  <i class="fa fa-arrow-left fa-fw comment-heading" @click="goBack()"></i>
  </div>
  <div class="col-md-11 col-sm-11 col-xs-11">
  <h4 class="comment-heading">Comments</h4>
  </div>
  </div>

    <div class="task-title">{{history_title}}</div>

    <div class="comment_form">
      <input v-model="hstudent_id" type="hidden" name="hstudent_id" id="hstudent_id">
      <input v-model="htask_id" type="hidden" name="htask_id" id="htask_id">
      <div style="clear: both"></div>
      <div class="label">Score:</div>
      <b-form-select
       class="input-text"
       v-model="score_selected"
       :options="score_options"
      >
      </b-form-select>
      <div class="label">Comments:</div>
      <textarea
        v-model="comments"
        placeholder="Add your comments"
        class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25"
        name="comments"
        maxlength="1000"
        >
      </textarea>
      <div style="clear: both" class="margin-bottom-10"></div>
      <div class="submit margin-bottom-10">
        <button type="submit" @click="onSubmit" class="submit_button btn btn-info btn-md">Submit</button>
        <button type="submit" @click="closeModal" class="margin-left-20 submit_button btn btn-grey btn-md">Cancel</button>
      </div>
      <div style="clear: both"></div>
    </div>
    <div style="clear: both"></div>
    <div v-show="assessment_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
    <div class="" v-for="assessment in history_comment">
      <div class="comment-wrapper mx-auto">
        <div class="tip left">
          <div class="row">
            <div class="col-12 float-left">
              <span class="assessment-task-score float-left">Score: {{assessment.score}}</span>
              <span class="comment-date float-right"><i class="fa fa-clock-o"> {{assessment.createdAt | formatDate}}</i></span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 comment-text">
              {{assessment.comment}}
            </div>
          </div>
          <div class="row">
            <div class="col-12 posted-by-text float-right">
              <span class="posted-by-mob float-right">Commented by: {{assessment.mentor_name}}</span>

            </div>
          </div>

        </div>
      </div>
    </div>
    <div v-if="history_comment.length == 0 && assessment_loading == false" class="comment-wrapper mx-auto">
      <div class="col-12 float-left override-padding">
        No Assessments Found.
      </div>
   </div>


  </div>

</transition>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import moment from 'moment';
import router from '../../router/index.js';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

export default {
  data() {
   return {
      'history_title': '',
      'history_comment': '',
      'score_selected': '',
      'comments': '',
      'hstudent_id': '',
      'htask_id': '',
      'hgroup_id': this.$route.params.group_id,
      'task_array': [],
      'assessment_loading': false,
      'tasklist_id': '',
      'score_options': [
        { value: '', text: 'Loading ...' },
      ],
    }
  },
  methods: {
    onSubmit() {
      axios.post('/assessment', {
        score: this.score_selected,
        comment: this.comments,
        mentee_id: this.hstudent_id,
        task_id: this.htask_id,
        tasklist_id: this.tasklist_id,
      })
      .then(response =>  {
        this.navigate("/students-tasks-detail/" + this.hgroup_id + "/" + this.task_array[0] + "?e1=" + this.task_array[2] + "&e2=" + this.task_array[1] + "&e3=" + this.$route.params.task_id + "&e4=" + this.hstudent_id + "");
      })
    },
    closeModal() {
      this.navigate("/students-tasks-detail/" + this.hgroup_id + "/" + this.task_array[0] + "?e1=" + this.task_array[2] + "&e2=" + this.task_array[1] + "&e3=" + this.$route.params.task_id + "&e4=" + this.hstudent_id + "");
    },
    goBack() {
      this.$router.go(-1);
    },
    navigate(path) {
      router.push(path);
    },
    getScoreLists() {
       axios.get('/score-lists', {

       })
       .then(response =>  {
          this.score_selected = 1;
          this.score_options = response.data;
       })
       .catch(function(error) {

       });
     },
    openHistoryModal(student_id, task_id) {
      this.assessment_loading = true;
      axios.get('/assessment', {
        params: {
          mentee_id: student_id,
          task_id: task_id,
          tasklist_id: this.tasklist_id,
        }
      })
      .then(response =>  {
        this.assessment_loading = false;
        this.hstudent_id = student_id;
        this.htask_id = task_id;
        this.history_title = response.data.task.description;
        this.history_comment = response.data.history;
      })
      .catch(function(error) {

      });
   },
  },
  created: function() {
    var student_id = this.$route.params.student_id;
    var task_id = this.$route.params.task_id;
    this.task_array = this.$route.params.parent_task_id.split('@');
    this.tasklist_id = this.task_array[0];
    this.openHistoryModal(student_id, task_id);
    this.getScoreLists();
  },
  beforeCreate: function() {
    document.body.className = 'task-assessment-page';
  }
}
</script>

<style scoped>
.submit_button {
  line-height: 20px;
}
.comment_form {
  margin-bottom: 40px;
}
.label {
  width: 100%;
  font-size: 14px;
  line-height: 35px;
  color: #000;
  padding: 0px;
}
.textarea {
  overflow-y: scroll;
  overflow-x: hidden;
  resize: none;
  height: 70px;
}
.select {
  height: 35px;
}

.comment_form {
  width: 90%;
  margin: 0 auto;
}
.comment-heading {
  background-color: #6c757d;
  padding: 12px 5px 12px 5px;
  font-size: 18px;
  color: #FFF;
  margin-top: 0px;
}
.comment-wrapper {
  padding: 5px;
  background-color: #FFF;
  width: 90%;
  min-height: 100px;
}
.task-title {
  margin: 0px 5px 5px 5px;
  border-bottom: 1px solid #DDD;
}
.task-score {
  font-weight: bold;
}
.comment-text {
  margin-top: 5px;
}
.tip:before {
  position: absolute;
  top: -14px;
  left: 98px;
  display: inline-block;
  border-right: 14px solid transparent;
  border-bottom: 14px solid #fff;
  border-left: 14px solid transparent;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  content: '';
}

.tip:after {
  position: absolute;
  top: -12px;
  left: 99px;
  display: inline-block;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #fff;
  border-left: 12px solid transparent;
  content: '';
}

.tip.left:before {
  border-top: 14px solid transparent;
  border-right: 14px solid #fff;
  border-bottom: 14px solid transparent;
  border-right-color: rgba(169, 169, 169, 1);
  left: -28px;
  top: 20px;
}

.tip.left:after {
  border-top: 12px solid transparent;
  border-right: 12px solid #fff;
  border-bottom: 12px solid transparent;
  left: -24px;
  top: 22px;
}
.tip-left {
  top: 10px;
  left: -25px;
  border-top-color: transparent;
  border-left-color: transparent;
  border-bottom-color: transparent;
}
.tip {
		background: #FFF;
		border: 2px solid #ccc;
		padding: 10px;
		position: relative;
	}
.dialogbox .body {
  position: relative;
  max-width: 300px;
  height: auto;
  margin: 20px 10px;
  padding: 5px;
  border-radius: 3px;
  border: 5px solid #ccc;
}
@media (max-width: 575.98px) {
  .col-xs-1 {
   width: 8.33333333%;
  }
  .col-xs-11 {
    width: 91.66666667%;
  }
  .col-xs-4 {
    width: 33.333333%;
  }
  .col-xs-8 {
    width: 66.666667%;
  }
  .col-xs-9 {
    width: 75%;
  }
  .col-xs-3 {
    width: 25%;
  }
}

.assessment-task-score {
  font-weight: bold;
}
.body .message {
  min-height: 30px;
  border-radius: 3px;
  font-family: Arial;
  font-size: 14px;
  line-height: 1.5;
  color: #797979;
}
    .slide-leave-active,
    .slide-enter-active {
      transition: 0.4s;
    }
    .slide-enter {
      transform: translate(100%, 0);
    }
    .slide-leave-to {
      transform: translate(-100%, 0);
    }
</style>



// WEBPACK FOOTER //
// src/components/instructor/student_add_task_assessment.vue